import axios from 'axios'
import { AlumniResource } from '@js/api/types/course/AlumniResource'

export interface GetAlumniResourcesResponse {
  data: AlumniResource[];
}

/**
 * Fetches course categories that have alumni resources
 *
 * @returns Promise with alumni resource data
 */
export const getAlumniResources = async (): Promise<GetAlumniResourcesResponse> => {
  try {
    const response = await axios.get<{data: AlumniResource[]}>('/api/dashboard/alumni.json')

    return response.data
  } catch (error) {
    console.error('Error fetching alumni resources:', error)
    throw error
  }
}
